module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Chapter_Page"
  }, [_c('h2', {
    staticClass: "chapno"
  }, [_c('a', {
    attrs: {
      "href": "#/03_Contents#s1"
    }
  }, [_c('b', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "href": "#/03_Contents#s1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img_p4.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a kid captured by a cannibal?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Stu!")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you get when you cross a bear with a skunk?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Winnie the Pew.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("When the moth hit the windshield, what was the last thing to go through its mind?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Its butt!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a cow with a twitch?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Beef jerky.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a hippy’s wife?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Mississippi.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("How does Darth Vader like his toast?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("On the dark side!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("If we breathe oxygen during the day, what do we breathe at night?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Nightrogen.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What’s the hardest thing about learning to skate?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("The ground!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What kind of bagel can fly?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("A plain bagel.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why shouldn’t you write with a broken pencil?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It’s pointless.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why couldn’t the gnome pay his rent?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("He was a little short.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a prehistoric pig?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Jurassic pork!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why is it dangerous to do math in the jungle?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because if you add 4 and 4, you get ate.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did dinosaurs walk so slowly?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because running shoes hadn’t been invented yet.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did the little strawberry cry?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Her mom and dad were in a jam.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did the rooster cross the road?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It was the chicken’s day off.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a fake noodle?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("An impasta.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why don’t zombies eat clowns?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("They taste funny!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you give to a sick lemon?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Lemon aid.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Who makes the best exploding underwear?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Fruit of the Boom!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a grizzly bear caught in a rain shower?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("A drizzly bear.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What kind of songs are balloons afraid of?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Pop songs!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What is every magician’s favorite candy bar?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Twix.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What’s white, furry, and shaped like a tooth?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("A molar bear.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Did you hear about the computer program created by a chicken?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("All you do is point and cluck.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What did the alpaca say when she was kicked off the farm?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("“Alpaca my bags!”")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What’s the most important rule for doing science experiments?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Never lick the spoon.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What would bears be without bees?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Ears!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you give a seasick monster?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Plenty of room!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did the cowboy ride the bull?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It was too heavy to carry.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Which Great Lake do ghosts like best?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Lake Eerie.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why do the French eat snails?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because they don’t like fast food.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("How did the frozen chicken cross the road?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("In a shopping bag.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a rabbit with fleas?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Bugs Bunny.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("If athletes get athlete’s feet, what do astronauts get?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Missile toe!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why can’t you hear a pterodactyl going to the bathroom?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because the “p” is silent.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you get when you cross a goat with a squid?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Billy the Squid.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Have you heard the joke about the peach?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It’s pitiful.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Which bird can hold three gallons of water in its bill?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("The pelican.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Where does Spider-Man go for medical advice?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Web MD.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why was the potato alone at the party?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It got there oily.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What’s the best time to visit the dentist?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Tooth-hurty!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Which state needs a handkerchief?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Mass-ACHOO!-setts.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why do fish choirs always sing off-key?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because you can’t tuna fish.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What kind of undies do clouds wear?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Thunderwear!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Did you hear about the frog that was illegally parked?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It got toad.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did the toilet paper roll down the hill?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("To get to the bottom.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("If April showers bring May flowers, what do May flowers bring?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Pilgrims!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a motorcycle with a good sense of humor?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("A Yamahahaha.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did the kid leave his piggy bank outside?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("He expected some change in the weather.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why didn’t the teddy bear eat his oatmeal?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("He was already stuffed!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What kind of books do skunks read?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Best-smellers.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why do vampires brush their teeth?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("To prevent bat breath.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Where do baby ghosts spend their days?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("At day-scare centers.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you call a sleeping T. rex?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("A dino-snore!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did the cantaloupe jump into the lake?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It wanted to be a watermelon.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why did the belt get arrested?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("It held up a pair of pants.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why are batteries always sad?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because they’re never included.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("How can you fall off a 100-foot ladder without getting hurt?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Easy! Fall from the bottom rung.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("How is Facebook like a refrigerator?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because every few minutes you open it to see if there’s anything good in it.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("If Pilgrims were alive today, what would they be most famous for?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Their age!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What’s the best day to go to the beach?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Sun-day.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do baby sweet potatoes wear to bed?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Their yammies!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What’s green, has big eyes, and is hard to see through?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Kermit the Fog.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What kind of car does a farmer drive?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("A corn-vertible.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Where do you send a shoe in the summer?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Boot camp!")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("Why were the early days of history called the Dark Ages?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Because there were so many knights.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What did one car muffler say to the other car muffler?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("“Boy, am I exhausted!”")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What should you shout if you swim into kelp and get caught in it?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("“Kelp!”")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What lives at the bottom of the ocean and is popular on Easter?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Oyster eggs.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What do you say to a hitchhiking angel?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("“Harp in!”")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("How do you make antifreeze?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Steal her blanket.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What has a big mouth but can’t talk?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("A jar.")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ques"
  }, [_c('b', [_vm._v("What’s red and smells like blue paint?")])]), _vm._v(" "), _c('p', {
    staticClass: "ans"
  }, [_c('b', [_vm._v("Red paint.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574b8d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Chapter1.vue
// module id = 69
// module chunks = 0